module.exports = __webpack_public_path__ + "img/mastercard.8b1c2b23.svg";